import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import { getAssetIds } from '../_helpers/pdfHelpers'
import { useParentServiceOrder } from './ParentServiceOrderLoader'

const Context = React.createContext([])
const { Provider } = Context
export const useAssetsFieldsValuesState = () => React.useContext(Context)
export const useAssetsFieldValues = () => useAssetsFieldsValuesState()?.assets || []

const QUERY = gql`
  query Asset($filter: AssetFilter) {
    assets(filter: $filter) {
      id
      name
      fieldValues {
        id
        value
        field {
          id
          name
        }
      }
    }
  }
`

const AssetsFieldValuesLoader = ({ children }) => {
  const serviceOrder = useServiceOrder()
  const parentServiceOrder = useParentServiceOrder()
  const assetIds = serviceOrder.checklist.id === 608 ? [] : getAssetIds(parentServiceOrder || serviceOrder)
  let { data, ...state } = useQuery(QUERY, {
    variables: { filter: { ids: assetIds, includeDisabled: true } },
    client: placesClient,
    skip: !assetIds.length || serviceOrder.checklist.id === 608
  })

  return (
    <StatePresenter {...state} noEmptyMessage>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AssetsFieldValuesLoader
